import { banrisulLogo, bbLogo, bradescoLogo, c6bankLogo, caixaLogo, interLogo, itauLogo, nubankLogo, pluggyLogo, santanderLogo, sicobLogo, sicrediLogo, unicredLogo, } from '@ibk/shared-assets';
import { ConsentBankState, OpenFinanceBankTypes } from '../../../../services/types';
import styles from '../../ContabilidadeDigitalDasboard.module.css';
export const bankData = {
    [OpenFinanceBankTypes.BANCO_DO_BRASIL]: {
        label: 'Banco do Brasil',
        logo: bbLogo,
    },
    [OpenFinanceBankTypes.BRADESCO]: {
        label: 'Bradesco',
        logo: bradescoLogo,
    },
    [OpenFinanceBankTypes.BANRISUL]: {
        label: 'Banrisul',
        logo: banrisulLogo,
    },
    [OpenFinanceBankTypes.CAIXA]: { label: 'Caixa', logo: caixaLogo },
    [OpenFinanceBankTypes.ITAU]: { label: 'Itaú', logo: itauLogo },
    [OpenFinanceBankTypes.NUBANK]: {
        label: 'Nubank',
        logo: nubankLogo,
    },
    [OpenFinanceBankTypes.SANTANDER]: {
        label: 'Santander',
        logo: santanderLogo,
    },
    [OpenFinanceBankTypes.SICOOB]: {
        label: 'Sicoob',
        logo: sicobLogo,
    },
    [OpenFinanceBankTypes.SICREDI]: {
        label: 'Sicredi',
        logo: sicrediLogo,
    },
    [OpenFinanceBankTypes.UNICRED]: {
        label: 'Unicred',
        logo: unicredLogo,
    },
    [OpenFinanceBankTypes.PLUGGY]: {
        label: 'Pluggy',
        logo: pluggyLogo,
    },
    [OpenFinanceBankTypes.INTER]: {
        label: 'Inter',
        logo: interLogo,
    },
    [OpenFinanceBankTypes.C6_BANK]: {
        label: 'C6 Bank',
        logo: c6bankLogo,
    },
};
export const statesStyles = {
    [ConsentBankState.VALIDATING]: styles.info,
    [ConsentBankState.VALID]: styles.success,
    [ConsentBankState.INVALID]: styles.error,
    [ConsentBankState.PENDING_ADDITIONAL_CONFIRMATION]: styles.info,
    [ConsentBankState.PENDING]: styles.info,
    [ConsentBankState.ERROR]: styles.error,
    [ConsentBankState.CONNECTING]: styles.info,
    [ConsentBankState.CONNECTED]: styles.success,
    [ConsentBankState.INVALID_CREDENTIALS]: styles.error,
    [ConsentBankState.PENDING_DEVICE_ENABLED]: styles.info,
    [ConsentBankState.CONNECTION_CLOSED]: styles.error,
    [ConsentBankState.WAITING_SECOND_SIGNATURE]: styles.info,
    [ConsentBankState.PENDING_MULTIPLE_SIGNATURES]: styles.info,
    [ConsentBankState.REDO_CONSENTMENT]: styles.info,
};
export const statesTranslationKeys = {
    [ConsentBankState.VALIDATING]: 'contabilidade-digital.bank-state-validating',
    [ConsentBankState.VALID]: 'contabilidade-digital.bank-state-valid',
    [ConsentBankState.INVALID]: 'contabilidade-digital.bank-state-invalid',
    [ConsentBankState.PENDING_ADDITIONAL_CONFIRMATION]: 'contabilidade-digital.bank-state-pending_additional_confirmation',
    [ConsentBankState.PENDING]: 'contabilidade-digital.bank-state-pending',
    [ConsentBankState.ERROR]: 'contabilidade-digital.bank-state-error',
    [ConsentBankState.CONNECTING]: 'contabilidade-digital.bank-state-connecting',
    [ConsentBankState.CONNECTED]: 'contabilidade-digital.bank-state-connected',
    [ConsentBankState.INVALID_CREDENTIALS]: 'contabilidade-digital.bank-state-invalid_credentials',
    [ConsentBankState.PENDING_DEVICE_ENABLED]: 'contabilidade-digital.bank-state-pending_device_enabled',
    [ConsentBankState.CONNECTION_CLOSED]: 'contabilidade-digital.bank-state-connection_closed',
    [ConsentBankState.WAITING_SECOND_SIGNATURE]: 'contabilidade-digital.bank-state-pending_additional_confirmation',
    [ConsentBankState.PENDING_MULTIPLE_SIGNATURES]: 'contabilidade-digital.bank-state-pending_additional_confirmation',
    [ConsentBankState.REDO_CONSENTMENT]: 'contabilidade-digital.bank-state-redo_consentment',
};
